import {useDebounceCallback} from '@react-hook/debounce'
import {RefObject, useEffect, useState} from 'react'

const DEBOUNCE_MS = 100

export const useSidebarOffset = (containerRef: RefObject<HTMLElement | null>): number => {
  const [offset, setOffset] = useState(0)
  const debouncedSetOffset = useDebounceCallback(setOffset, DEBOUNCE_MS)

  useEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    const updateOffset = () => {
      debouncedSetOffset(container.getBoundingClientRect().left)
    }

    updateOffset()

    const observer = new ResizeObserver(updateOffset)
    observer.observe(container)

    return () => {
      observer.disconnect()
    }
  }, [containerRef, debouncedSetOffset])

  return offset
}
